/* Stylesheet */

.value_container {
  display: flex;
  justify-content: space-between;
  color: var(--ion-color-text-secondary);
  font-size: 0.875rem;
}
